const WelcomePage = () => {

    return (
        <div className="page-section  login-section">
            <div className="section-title">Welcome to StitchBean</div>
        </div>
    )
}
export default WelcomePage